/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgUnderlineA = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 2048 2048",
        width: "1em",
        height: "1em",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "m660 1325-169 467H270L920 128h206l652 1664h-219l-180-467H660zm66-175h588l-266-709q-10-27-15-55t-11-56h-5q-5 28-11 56t-16 55l-264 709zm-470 770h1536v128H256v-128z"
    }));
export default SvgUnderlineA;
